import FilterTag from "@plugins/filter-tag/components/FilterTag";
import FilterTagList from "@plugins/filter-tag/components/FilterTagList";

const Plugin = {
  install(app) {
    app.component("filter-tag", FilterTag);
    app.component("filter-tag-list", FilterTagList);
  },
};

export default Plugin;
